// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-md-editor-area {
  overflow: auto;
  border-radius: 5px;
}
.w-md-editor-text {
  min-height: 100%;
  position: relative;
  text-align: left;
  white-space: pre-wrap;
  word-break: keep-all;
  overflow-wrap: break-word;
  box-sizing: border-box;
  padding: 10px;
  margin: 0;
  font-size: 14px !important;
  line-height: 18px !important;
  font-variant-ligatures: common-ligatures;
}
.w-md-editor-text-pre,
.w-md-editor-text-input,
.w-md-editor-text > .w-md-editor-text-pre {
  margin: 0;
  border: 0;
  background: none;
  box-sizing: inherit;
  display: inherit;
  font-family: inherit;
  font-family: var(--md-editor-font-family) !important;
  font-size: inherit;
  font-style: inherit;
  font-variant-ligatures: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  tab-size: inherit;
  text-indent: inherit;
  text-rendering: inherit;
  text-transform: inherit;
  white-space: inherit;
  overflow-wrap: inherit;
  word-break: inherit;
  word-break: normal;
  padding: 0;
}
.w-md-editor-text-pre {
  position: relative;
  margin: 0px !important;
  pointer-events: none;
  background-color: transparent !important;
}
.w-md-editor-text-pre > code {
  padding: 0 !important;
  font-family: var(--md-editor-font-family) !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
.w-md-editor-text-input {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  resize: none;
  color: inherit;
  overflow: hidden;
  outline: 0;
  padding: inherit;
  -webkit-font-smoothing: antialiased;
  -webkit-text-fill-color: transparent;
}
.w-md-editor-text-input:empty {
  -webkit-text-fill-color: inherit !important;
}
.w-md-editor-text-pre,
.w-md-editor-text-input {
  word-wrap: pre;
  word-break: break-word;
  white-space: pre-wrap;
}
/**
 * Hack to apply on some CSS on IE10 and IE11
 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /**
    * IE doesn't support '-webkit-text-fill-color'
    * So we use 'color: transparent' to make the text transparent on IE
    * Unlike other browsers, it doesn't affect caret color in IE
    */
  .w-md-editor-text-input {
    color: transparent !important;
  }
  .w-md-editor-text-input::selection {
    background-color: #accef7 !important;
    color: transparent !important;
  }
}
.w-md-editor-text-pre .punctuation {
  color: var(--color-prettylights-syntax-comment, #8b949e) !important;
}
.w-md-editor-text-pre .token.url,
.w-md-editor-text-pre .token.content {
  color: var(--color-prettylights-syntax-constant, #0550ae) !important;
}
.w-md-editor-text-pre .token.title.important {
  color: var(--color-prettylights-syntax-markup-bold, #24292f);
}
.w-md-editor-text-pre .token.code-block .function {
  color: var(--color-prettylights-syntax-entity, #8250df);
}
.w-md-editor-text-pre .token.bold {
  font-weight: unset !important;
}
.w-md-editor-text-pre .token.title {
  line-height: unset !important;
  font-size: unset !important;
  font-weight: unset !important;
}
.w-md-editor-text-pre .token.code.keyword {
  color: var(--color-prettylights-syntax-constant, #0550ae) !important;
}
.w-md-editor-text-pre .token.strike,
.w-md-editor-text-pre .token.strike .content {
  color: var(--color-prettylights-syntax-markup-deleted-text, #82071e) !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@uiw/react-md-editor/esm/components/TextArea/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;;;EAGE,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,oDAAoD;EACpD,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE;AACF;EACE;;;;KAIG;EACH;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,6BAA6B;EAC/B;AACF;AACA;EACE,mEAAmE;AACrE;AACA;;EAEE,oEAAoE;AACtE;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,uDAAuD;AACzD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,oEAAoE;AACtE;AACA;;EAEE,+EAA+E;AACjF","sourcesContent":[".w-md-editor-area {\n  overflow: auto;\n  border-radius: 5px;\n}\n.w-md-editor-text {\n  min-height: 100%;\n  position: relative;\n  text-align: left;\n  white-space: pre-wrap;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n  box-sizing: border-box;\n  padding: 10px;\n  margin: 0;\n  font-size: 14px !important;\n  line-height: 18px !important;\n  font-variant-ligatures: common-ligatures;\n}\n.w-md-editor-text-pre,\n.w-md-editor-text-input,\n.w-md-editor-text > .w-md-editor-text-pre {\n  margin: 0;\n  border: 0;\n  background: none;\n  box-sizing: inherit;\n  display: inherit;\n  font-family: inherit;\n  font-family: var(--md-editor-font-family) !important;\n  font-size: inherit;\n  font-style: inherit;\n  font-variant-ligatures: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n  tab-size: inherit;\n  text-indent: inherit;\n  text-rendering: inherit;\n  text-transform: inherit;\n  white-space: inherit;\n  overflow-wrap: inherit;\n  word-break: inherit;\n  word-break: normal;\n  padding: 0;\n}\n.w-md-editor-text-pre {\n  position: relative;\n  margin: 0px !important;\n  pointer-events: none;\n  background-color: transparent !important;\n}\n.w-md-editor-text-pre > code {\n  padding: 0 !important;\n  font-family: var(--md-editor-font-family) !important;\n  font-size: 14px !important;\n  line-height: 18px !important;\n}\n.w-md-editor-text-input {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  width: 100%;\n  resize: none;\n  color: inherit;\n  overflow: hidden;\n  outline: 0;\n  padding: inherit;\n  -webkit-font-smoothing: antialiased;\n  -webkit-text-fill-color: transparent;\n}\n.w-md-editor-text-input:empty {\n  -webkit-text-fill-color: inherit !important;\n}\n.w-md-editor-text-pre,\n.w-md-editor-text-input {\n  word-wrap: pre;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n/**\n * Hack to apply on some CSS on IE10 and IE11\n */\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /**\n    * IE doesn't support '-webkit-text-fill-color'\n    * So we use 'color: transparent' to make the text transparent on IE\n    * Unlike other browsers, it doesn't affect caret color in IE\n    */\n  .w-md-editor-text-input {\n    color: transparent !important;\n  }\n  .w-md-editor-text-input::selection {\n    background-color: #accef7 !important;\n    color: transparent !important;\n  }\n}\n.w-md-editor-text-pre .punctuation {\n  color: var(--color-prettylights-syntax-comment, #8b949e) !important;\n}\n.w-md-editor-text-pre .token.url,\n.w-md-editor-text-pre .token.content {\n  color: var(--color-prettylights-syntax-constant, #0550ae) !important;\n}\n.w-md-editor-text-pre .token.title.important {\n  color: var(--color-prettylights-syntax-markup-bold, #24292f);\n}\n.w-md-editor-text-pre .token.code-block .function {\n  color: var(--color-prettylights-syntax-entity, #8250df);\n}\n.w-md-editor-text-pre .token.bold {\n  font-weight: unset !important;\n}\n.w-md-editor-text-pre .token.title {\n  line-height: unset !important;\n  font-size: unset !important;\n  font-weight: unset !important;\n}\n.w-md-editor-text-pre .token.code.keyword {\n  color: var(--color-prettylights-syntax-constant, #0550ae) !important;\n}\n.w-md-editor-text-pre .token.strike,\n.w-md-editor-text-pre .token.strike .content {\n  color: var(--color-prettylights-syntax-markup-deleted-text, #82071e) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
